import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';
import { AuthenticationService } from '../app/core/services/auth.service'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

  securityHeader: any[] = [];

  constructor(
    private router: Router,
    private http: HttpClient,
    public authService: AuthenticationService,

  ) {
    //console.log("I AM IN THE APP COMPONENT");
    // console.log("App Component: " +  localStorage.getItem("userData"))
    if (
      localStorage.getItem("userData") == "" ||
      localStorage.getItem("userData") == null

    ) {
      this.router.navigate(['/account/login']);
      //console.log("NO USER ID");
    } else {
      //console.log("USER ID FOUND");
      this.router.navigate(["/dashboard"]);
    }
  }

  securityHeaders() {
    let body = {
      companyid: "1",
    };

    this.authService.postData(body, "securityHeaders.php")
      .subscribe((res: any) => {
        // Check if 'result' exists in the response
        if (res && res.result) {
          this.securityHeaders = JSON.parse(JSON.stringify(res.result));
        } else {
          // console.error('Unexpected or missing response structure:', res);
          // Handle unexpected or missing response structure here
        }
      });
  }

  ngOnInit() {
    this.securityHeaders();
    // document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
  }
}
